import React, { useEffect, useState } from "react";
import { useIsAuthed } from "../../../auth";
import "./LogInButton.styles.scss"

const LogInButton = () => {
	const [isLoggedIn, setIsLoggedIn] = useState(false);
	const isAuth = useIsAuthed();

	useEffect(() => {
		if (!isAuth) return;
		setIsLoggedIn(true);
	}, [isAuth]);

	return (
		<>
			{!isLoggedIn ? (
				<div className="log-in-button">
					<a href="/app/login">Log In</a>
				</div>
			) : null}
		</>
	);
};

export default LogInButton;
